import { createStructuredSelector } from 'reselect';

export const selectResponseError = state => state.usersList.error;

export default createStructuredSelector({ responseError: selectResponseError });
